<article class="components">
  <header class="components__header">
    <ng-content select="[title]"></ng-content>
    <ng-content select="[description]"></ng-content>
  </header>
  <section class="components__content">
    <ng-content select="[content]"></ng-content>
  </section>
</article>
